export function authErrorMessage(error: unknown): string {
  const code = (error as { data?: { code?: number } })?.data?.code
  if (code === 2254) return 'Registration is currently unavailable.'
  if (code === 2259) return 'This account exists but is not activated. Please activate it before signing in.'
  if (code === 2261) return 'Email/password login is currently disabled. Try Google sign-in if it is available.'
  if (code === 2262) return 'Google login is currently disabled. Sign in with email and password instead.'
  const message = (error as { message?: string })?.message
  return message || 'Authentication failed. Please try again.'
}

export function emailErrorMessage(error: unknown): string {
  const message = (error as { message?: string })?.message || ''
  const lower = message.toLowerCase()
  if (lower.includes('recipient') || lower.includes('not found') || lower.includes('not registered')) {
    return 'The solution can only be emailed to a registered FunMathCalculator account.'
  }
  if (lower.includes('auth') || lower.includes('unauthor') || lower.includes('sign')) {
    return 'Sign in to email this step-by-step solution to your student inbox.'
  }
  return message || 'Could not send the solution email. Please try again.'
}
